import * as Yup from 'yup';

export const generationYopValidation = () => {
  return Yup.object().shape({
    byPass: Yup.string(),
    focusOn: Yup.string(),
    fileText: Yup.string(),
    url: Yup.string().required('required'),
    docs: Yup.mixed().nullable(),
  });
};
